import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="border-b border-[var(--line)] bg-[var(--bg-alt)] py-16 sm:py-20" data-id="element-103" data-mp="4uqdmw6js2tb">
      <div className="mx-auto max-w-3xl px-4" data-id="element-104" data-mp="9umkr4ajkad3">
        <div className="rounded-2xl border border-[var(--rose)]/35 bg-[var(--surface)] p-8 text-center sm:p-12" data-id="element-105" data-mp="9srxvkfpm86d">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[var(--rose)]/15" data-id="element-106" data-mp="ercvrd7hofrn">
            <ShieldCheckIcon className="h-9 w-9 text-[var(--rose)]" aria-hidden="true" data-id="element-107" data-mp="jqpryok92z6w" />
          </span>
          <h2 className="mt-6 font-serif-display text-3xl font-bold text-[var(--text)] sm:text-4xl" data-id="element-108" data-mp="slvrj5sxgl0z">
            Garantía 7 días — Sin preguntas
          </h2>
          <p className="mt-5 text-[var(--text)]/80" data-id="element-109" data-mp="12j0idixpx4o4">
            Descargás los tomos. Los usás en el mat.
          </p>
          <p className="mt-2 text-[var(--text)]/80" data-id="element-110" data-mp="17hljdkksnsdm">
            Si en 7 días no es lo que esperabas:
          </p>
          <p className="mt-4 text-lg font-semibold text-[var(--rose)]" data-id="element-111" data-mp="25sykwtyk9khr">
            Devolución del 100% · Sin formularios · Sin drama.
          </p>
          <p className="mt-4 text-sm text-[var(--text-soft)]" data-id="element-112" data-mp="20v6vq7pawch9">
            Tasa de devoluciones: 0,8% (porque funciona).
          </p>
        </div>
      </div>
    </section>;
}